import React, {useContext, useMemo, useState} from 'react';
import _ from 'lodash';
import {SidebarAnimationSpeed} from './shared-components/variables/VariableSize';

const SidebarContext = React.createContext({
    sidebarOpen: false,
    sidebarClosing: false,
    openSidebar: () => {},
    closeSidebar: () => {},
});

/**
 * A React Higher Order Component (HOC) used to communicate whether the sidebar is open or not, which should
 * lead to grid adjustments in the closest grid component (e.g. the MainContent)
 */
export function WithSidebarContext({children}) {
    const [sidebarState, setSidebarState] = useState('closed'); // state can be 'closed', 'open', 'closing'

    const context = useMemo(
        () => ({
            sidebarOpen: sidebarState === 'open' || sidebarState === 'closing',
            sidebarClosing: sidebarState === 'closing',
            openSidebar: () => setSidebarState('open'),
            closeSidebar: (onDone) => {
                if (sidebarState === 'open') {
                    setSidebarState('closing');
                    if (_.isFunction(onDone)) onDone();
                    setTimeout(() => {
                        setSidebarState('closed');
                    }, SidebarAnimationSpeed + 10); // add 10ms to make sure the animation is fully done
                }
            },
        }),
        [sidebarState, setSidebarState],
    );

    return <SidebarContext.Provider value={context}>{children(context)}</SidebarContext.Provider>;
}

export const useSidebarContext = () => useContext(SidebarContext);
